import Title from "../../components/Title";

import "./Submitted.scss";

function Submitted() {

    return (
        <div className="form__content__step container">
            <div className="row">
                <div className="form__content__step__submitted col-12">
                    <div className="form__content__step__groupTitles-submitted mb-4 mb-md-7">
                        <Title title="Gracias por contarnos cómo es la casa de tus sueños."/>
                        <Title title="A partir de ahora, La Casa que Eres está más cerca."/>
                    </div>
                    <div>
                        <a href={"/promociones"}>
                            <button className="btn btn-primary">Conoce nuestras promociones</button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Submitted;
